// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_6Ry","textarea":"styles_textarea__2t-lw"};